import React, { useCallback } from 'react'

import { Form, hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withForm = Component => props => {
  const getActionListener = hooks.useSearchListener('action', 'staff_history_action')
  const getEventListener = hooks.useSearchListener('event', 'staff_history_event')

  const onSubmit = useCallback(Callbacks.onSubmitHandler(getActionListener, getEventListener), [getActionListener, getEventListener])

  const mergedProps = {
  }

  return (
    <Form
      name='staff_history_search'
      initialValues={{}}
      initialState={{ isReadOnly: false }}
      status={{ isReady: true }}
      onSubmit={onSubmit}
      closeOnSuccess={false}
      submitOnMount
      submitOnEmpty
      submitOnEnter
      submitOnReset
    >
      <Component {...mergedProps} />
    </Form>
  )
}

export default withForm
